<template>
	<div>
		<div class="maps" v-if="this.$route.meta.showMap" data-aos="fade-up">
			<!-- 地图 -->
			<yandex-map :coords="map.coords" :option="map.option" :zoom="map.zoom" :controls="map.controls">
				<ymap-marker v-for="(item, key) in map.markerList" :key="key" :markerId="key" :coords="item.coords"
					:controls="item.controls" :icon="item.icon" :properties="item.properties"></ymap-marker>
			</yandex-map>

			<div class="select">
				<div class="selectContent" v-if="this.$route.meta.showSelect">
					<el-collapse v-model="mapSelectIndex" @change="mapSelectChange" accordion>
						<el-collapse-item :name="String(key)" v-for="(item, key) in $store.state.navShow == true ? mapSelectList : mapSelectListE" :key="key">
							<!-- 标题 -->
							<template slot="title">
								<span class="title">{{ item.name }}</span>
							</template>
							<p class="site">
								<el-image :src="mapSelect.site"></el-image>
								<span>{{ item.address }}</span>
							</p>
							<p v-if="item.phone" class="phone">
								<el-image :src="mapSelect.phone"></el-image>
								<span>{{ item.phone }}</span>
							</p>
							<p v-if="item.email" class="email">
								<el-image :src="mapSelect.email"></el-image>
								<span>{{ item.email }}</span>
							</p>
						</el-collapse-item>
					</el-collapse>
				</div>
			</div>
		</div>
		<!-- 联系我们 -->
		<div class="footer">
			<div class="contactUs">
				<div class="Title">{{$store.state.navShow == true ? '联系我们':'Contact Us'}}</div>
				<div class="contactCons">
					<div class="QRcode">
						<img :src="contactUsList.ewm" alt="" />
					</div>
					<div class="contactInformation">
						<div class="phoneTitle">{{$store.state.navShow == true ? '业务联系: ':'Tel: '}}</div>
						<div class="phoneNumber">{{$store.state.navShow == true ? footerData.business_telephone : footerDataE.business_telephone}}</div>
						<div class="FootEmail footSpan">
							<span class="spanTitle">{{$store.state.navShow == true ? '电子邮箱：':'Email：'}}</span>
							<span class="spanContent">{{$store.state.navShow == true ? footerData.business_mailbox : footerDataE.business_mailbox }}</span>
						</div>
						<div class="FootEmail footSpan">
							<span class="spanTitle">{{$store.state.navShow == true ? '公司地址：':'Address：'}}</span>
							<span class="spanContent">{{  $store.state.navShow == true ? footerData.company_address : footerDataE.company_address }}</span>
						</div>
					</div>
				</div>
			</div>

			<div class="IndustryInformation">
				<div class="Title">{{$store.state.navShow == true ? '行业资讯':'Industry information'}}</div>
				<div class="newsCon">
					<div v-for="(item, index) in real_timeImgList" :key="index">
						<img :src="item.img" alt="" />
					</div>
				</div>
			</div>

			<div class="socialContact">
				<img v-for="(item, index) in socialContactImgList" :key="index" @click="JumpClick($event)"
					:data-index='index' :src="item.img" alt="" />
			</div>

			<div class="recordNo">
				Copyright 2019-2020 © MG-GROUP 备案号：{{ footerData.web_site_icp }}
			</div>
		</div>
		<el-backtop></el-backtop>
	</div>
</template>

<script>
	export default {
		data() {

			return {
				socialContactImgList: [{ // 社交图片
						img: require("@/assets/home_footer/socialContact01.jpg"),
					},
					{
						img: require("@/assets/home_footer/socialContact02.jpg"),
					},
					{
						img: require("@/assets/home_footer/socialContact03.jpg"),
					},
				],
				footerData: [], // 底部其他数据
				footerDataE: [], // 底部其他数据
				addressCard: [],
				// 地图浮层选择
				mapSelect: {
					site: require("../assets/home_footer/site.png"), //  位置
					phone: require("../assets/home_footer/phone.png"), //  手机号
					email: require("../assets/home_footer/email.png"), //  邮箱
				},
				// 联系我们数据
				contactUsList: {
					ewm: require("@/assets/home_footer/ewm.png"),
					contactInformation: [{
							title: "电子邮箱：",
							con: "ysy@margingroup.cn",
						},
						{
							title: "公司地址：",
							con: "河北省石家庄市裕华区体育南 大街399号4层",
						},
					],
				},
				// 资讯图片
				real_timeImgList: [{
						img: require("@/assets/home_footer/real-time01.jpg"),
					},
					{
						img: require("@/assets/home_footer/real-time02.jpg"),
					},
					{
						img: require("@/assets/home_footer/real-time03.jpg"),
					},
					{
						img: require("@/assets/home_footer/real-time04.jpg"),
					}
				],
				//  地图
				map: {
					coords: [-30.82896654088406, 70.831893822753904], //  中心位置
					zoom: 2, //  地图缩放
					controls: [
						"rulerControl", //  标尺
						"typeSelector", //  切换地图类型
						"zoomControl", //  缩放滑块
						"trafficControl", //  交通拥堵转状况
						"geolocationControl", //  确定用户位置
						"fullscreenControl", //  全屏控件
					], //  地图控制器
					markerList: [], //  标记列表
				},
				mapSelectList: [],
				mapSelectListE: [],
				mapSelectIndex: "0", //  当前折叠打开的菜单位置
				showMap: false,
			};
		},

		mounted() {
			// console.log("showMapthis", this.$route.meta.showMap);
			// this.showMap = this.$route.meta.showMap;
			/**
			 * 底部数据 接口
			 * 罗锦炜
			 * 2021-11-29
			 */
			this.$axios.get("/api/Index/footer").then((res) => {
				console.log("底部数据=>", res);
				if (res.data.code === 1) {
					// 除了新闻 其余的数据
					this.footerData = res.data.data.footerConfig;
					// console.log('底部数据除了新闻=>',this.footerData)
					// 最新新闻
					this.newsXinInfoArr = res.data.data.news.map((item) => {
						// console.log('item=>',item)
						return item;
					});
				} else {
					this.$message({
						showClose: true,
						message: "底部数据：" + res.data.msg,
						type: "error",
					});
				}
			});
			this.$axios.get("/apien/Index/footer").then((res) => {
				console.log("底部数据=>", res);
				if (res.data.code === 1) {
					// 除了新闻 其余的数据
					this.footerDataE = res.data.data.footerConfig;
					// console.log('底部数据除了新闻=>',this.footerData)
					// 最新新闻
					this.newsXinInfoArr = res.data.data.news.map((item) => {
						// console.log('item=>',item)
						return item;
					});
				} else {
					this.$message({
						showClose: true,
						message: "底部数据：" + res.data.msg,
						type: "error",
					});
				}
			});

			/**
			 * 友情链接与合作公司地址 接口
			 * 罗锦炜
			 * 2021-11-29
			 */
			if (!this.$route.meta.hideSelect) {
				this.$axios.get("/api/Index/linksAndAddress").then((res) => {
					console.log("友情链接与合作公司地址", res.data);
					if (res.data.code === 1) {
						// 地图上显示的卡片
						this.mapSelectList = res.data.data.addressCard;
						// console.log('this.mapSelectList', this.mapSelectList)
						// 地图标记
						this.map.markerList = res.data.data.address.map((item) => {
							return {
								coords: [Number(item.latitude), Number(item.longitude)],
								icon: {
									color: "blue", //  图标颜色
									glyph: "HomeCircle", //  中心图标类型
								},
								properties: {
									iconCaption: item.name,
									balloonContent: this.initInfoContent({
										img: item.thumb,
										site: item.address,
										phone: item.phone,
										email: item.email,
									}),
								},
							};
						});
						// console.log('this.map.markerList =》 ', this.map.markerList)

						// 中心位置也跟着中心变化
						this.map.coords = this.map.markerList[0].coords;
					} else {
						this.$message({
							showClose: true,
							message: "地图，" + res.data.msg,
							type: "error",
						});
					}
				});

				this.$axios.get("/apien/Index/linksAndAddress").then((res) => {
					console.log("友情链接与合作公司地址EEEEEEE", res.data);
					if (res.data.code === 1) {
						// 地图上显示的卡片
						this.mapSelectListE = res.data.data.addressCard;
						// console.log('this.mapSelectList', this.mapSelectList)
						// 地图标记
						this.map.markerList = res.data.data.address.map((item) => {
							return {
								coords: [Number(item.latitude), Number(item.longitude)],
								icon: {
									color: "blue", //  图标颜色
									glyph: "HomeCircle", //  中心图标类型
								},
								properties: {
									iconCaption: item.name,
									balloonContent: this.initInfoContent({
										img: item.thumb,
										site: item.address,
										phone: item.phone,
										email: item.email,
									}),
								},
							};
						});
						// console.log('this.map.markerList =》 ', this.map.markerList)

						// 中心位置也跟着中心变化
						this.map.coords = this.map.markerList[0].coords;
					} else {
						this.$message({
							showClose: true,
							message: "地图，" + res.data.msg,
							type: "error",
						});
					}
				});
			}

			/**
			 * 联系我们页面seo与公司地标  地图接口
			 * 罗锦炜
			 * 2021-11-29
			 */
			// console.log("this", this.$route.meta.showMap);
			// if (this.$route.meta.showMap === true) {
			// 	this.$axios.get("/api/Contactus/index").then((result) => {
			// 		console.log("联系我们", result.data);
			// 		if (result.data.code === 1) {
			// 			this.map.markerList = result.data.data.address.map((item) => {
			// 				return {
			// 					coords: [Number(item.latitude), Number(item.longitude)],
			// 					icon: {
			// 						color: "blue", //  图标颜色
			// 						glyph: "HomeCircle", //  中心图标类型
			// 					},
			// 					properties: {
			// 						iconCaption: item.name,
			// 						balloonContent: this.initInfoContent({
			// 							img: item.thumb,
			// 							site: item.address,
			// 							phone: item.phone,
			// 							email: item.email,
			// 						}),
			// 					},
			// 				};
			// 			});
			// 			// 中心位置也跟着中心变化
			// 			this.map.coords = this.map.markerList[0].coords;
			// 		}
			// 	});
			// }
		},
		methods: {
			/**
			 * 最新新闻每一项 点击事件
			 * 罗锦炜
			 * 2021-11-29
			 */
			newItemClick(id) {
				//   console.log('id', id)
				//   this.$router.push('/new_details')
				//   this.$router.push({
				//     path: '/new_details',
				//     query: {
				//       newId: id // newId需要和 /new_details 页面接收的id一致
				//     }
				//   })

				this.$router.push({
					path: "/ownJumpPage",
					query: {
						path1: "/new_details",
						newId: id, // newId需要和 /new_details 页面接收的id一致
					},
				});

				// document.documentElement.scrollTop = 0
			},

			/**
			 * vk 点击事件
			 * 罗锦炜
			 * 2021-11-29
			 */
			JumpClick(e) {
				let index = e.target.attributes["data-index"].value;
				if (index == 0) {
					window.open(this.footerData.vk_link, "_blank"); // 打开新的窗口
				} else if (index == 1) {
					window.open(this.footerData.facebook_link, "_blank"); // 打开新的窗口
				} else if (index == 2) {
					window.open(this.footerData.instagram_link, "_blank"); // 打开新的窗口
				}
			},
			/**
			 * facebook 点击事件
			 * 罗锦炜
			 * 2021-11-29
			 */
			facebookClick() {},
			/**
			 * instagram 点击事件
			 * 罗锦炜
			 * 2021-11-29
			 */
			instagramClick() {},

			/**
			 * 地图 - 折叠面板更新事件s
			 */
			mapSelectChange(event) {
				if (event !== "") {
					this.mapSelectIndex = event;
				}
			},

			/**
			 * 初始化地图标记
			 */
			initMarker() {
				this.map.markerList = [{
						coords: [54.82896654088406, 39.831893822753904],
						icon: {
							color: "blue", //  图标颜色
							glyph: "HomeCircle", //  中心图标类型
						},
						properties: {
							iconCaption: "这里是标记文字",
							balloonContent: this.initInfoContent({
								img: this.industryInfoShowArr[0].industryInfoIMg,
								site: "北京市昌平区",
								phone: "+86 15033333333",
								email: "10000000@163.com",
							}),
						},
					},
					{
						coords: [54.82896654088406, 40],
						icon: {
							color: "blue", //  图标颜色
							glyph: "HomeCircle", //  中心图标类型
						},
						properties: {
							iconCaption: "这里是标记文字",
							balloonContent: this.initInfoContent({
								img: this.industryInfoShowArr[0].industryInfoIMg,
								site: "北京市昌平区",
								phone: "+86 15033333333",
								email: "10000000@163.com",
							}),
						},
					},
				];
			},
			/**
			 * 创建地图信息模板
			 */
			initInfoContent(option) {
				const {
					img,
					site,
					phone,
					email
				} = option;
				return `
            <div class="TemplateTip">
                <div class="image">
                    <img src="${img}">
                </div>
                <div class="content">
                    <p class="city">${site}</p>
                    <p>
                        <span>Phone：</span>
                        <span>${phone}</span>
                    </p>
                    <p>
                        <span>E-mail：</span>
                        <span>${email}</span>
                    </p>
                </div>
            </div>
        `;
			},
		},
	};
</script>

<style lang="less">
	#id_163901620445812763072 {
		width: 12.5rem !important;
		height: 3.125 !important;
	}

	.maps {
		width: 100%;
		height: 750px;
		background-color: aqua;
		position: relative;

		.ymap-container {
			width: 100%;
			height: 100%;
		}

		.select {
			width: 100%;
			height: 55%;
			margin: 0 auto;
			position: absolute;
			// top: 40%;
			bottom: 0;

			.selectContent {
				.el-collapse {
					border-top: none;
				}

				.el-collapse-item__header {
					background-color: #eaf0f6;
					border-bottom: 1px solid #FFFFFF;

					&>i::before {
						color: #3C71B6;
						;
						font-weight: bold;
						font-size: 0.9375rem;
					}

					&>i {
						margin-right: 0.825rem;
					}
				}

				.is-active {
					background-color: #2d6aab;

					& .title {
						color: #fff;
						font-weight: bold;
					}

					& .title::before {
						background-color: #fff;
						color: #fff;
					}

					&::before {
						color: #fff;
						font-weight: bold;
					}

					&>i::before {
						color: #fff;
						;
						font-weight: bold;
					}
				}

				width: 83%;
				margin: 0 auto;
				background-color: #fff;

				& .title {
					display: flex;
					align-items: center;

					&::before {
						content: "";
						display: inline-block;
						width: 12px;
						height: 3px;
						margin-right: 15px;
						margin-left: 17px;
						background-color: #2d6aab;
					}
				}

				& p {
					display: flex;
					align-items: center;
					// line-height: 28px;
					color: #2d6aab;
					width: 85%;
					margin-left: 17px;
					margin-top: 0.9375rem;

					&>.el-image {
						display: flex;
						align-items: center;
						justify-content: center;
						margin-right: 10px;
						min-width: 15px;
					}

					&.site {
						// height: 48px;
						color: #666666;

						// margin-bottom: 6px;
						&>.el-image {
							&>img {
								width: 12px; //  19*23
								height: 16px;
							}
						}
					}

					&.phone {
						font-size: 24px;
						font-weight: bold;
						letter-spacing: -2px;

						&>.el-image {
							&>img {
								width: 12px; //19*21
								height: 14px;
							}

						}
					}

					&.email {
						&>.el-image {
							&>img {
								width: 12px; //19*17
								height: 10px;
							}

						}
					}

					&>span {
						text-align: left;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 2;
					}
				}
			}
		}
	}
</style>

<style lang="less">
	@z: 0.5px;

	.footer {
		width: 92%;
		// height: 700 * @z;
		height: auto;
		background-color: #2d6aab;
		padding: 76 * @z 4%;

		.Title {
			font-size: 26 * @z;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #ffffff;
			display: flex;
			justify-content: flex-start;
			align-content: center;
			margin-bottom: 30 * @z;
		}

		img {
			width: 100%;
			height: 100%;
		}

		.contactUs {
			width: 100%;
			// height: 100%;
			display: flex;
			flex-direction: column;
			// justify-content: center;
			align-content: center;
			margin-bottom: 80 * @z;

			.contactCons {
				display: flex;

				.QRcode {
					width: 210 * @z;
					min-width: 210 * @z;
					height: 210 * @z;
					background-color: #fff;
					margin-right: 43 * @z;
				}

				& .contactInformation {
					text-align: left;

					.phoneTitle {
						font-size: 20 * @z;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #ffffff;
						margin-bottom: 0.1875rem;
					}

					.phoneNumber {
						font-size: 50 * 0.131vw;
						font-family: AkzidenzGroteskBQ;
						font-weight: normal;
						font-weight: bold;
						color: #ffffff;
						margin-bottom: 0.5rem;
					}

					.FootEmail {
						font-size: 22 * 0.131vw;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #ffffff;
						margin-bottom: 0.125rem;
					}

					.footSpan {
						display: flex;

						span {
							display: block;
						}

						.spanTitle {
							width: 60px;
						}

						.spanContent {
							width: 150px;
						}
					}
				}
			}
		}

		.IndustryInformation {
			width: 100%;
			display: flex;
			flex-direction: column;
			margin-bottom: 70 * @z;

			.newsCon {
				display: flex;
				justify-content: space-between;
				align-content: center;

				div {
					width: 156 * @z;
					height: 156 * @z;
					// background-color: #fff;
					// margin-right: 20 * @z;
				}
			}
		}

		.socialContact {
			width: 100%;
			display: flex;
			justify-content: center;
			align-content: center;
			border-radius: 50%;
			margin-bottom: 45 * @z;

			img {
				width: 68 * @z;
				height: 68 * @z;
				margin: 0 35.5 * @z;
				border-radius: 50%;
			}
		}

		.recordNo {
			font-size: 18 * @z;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #8bc3ff;
		}
	}
</style>
